import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Select, Store } from '@ngxs/store';
import {UpdateEmail, UpdatePin} from '../../../state/actions/merchant.actions';
import { StopLoading } from '../../../state/actions/general.actions';
import { CustomValidators } from '../../../shared/validators/customValidators';
import { AppState } from '../../../state/appState';
import { Observable } from 'rxjs';
import { GatewayConfigModel } from '../../../shared/services/gateway-config/gatewayConfig.model';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-account-change-email',
  templateUrl: './account-change-email.component.html',
  styleUrls: ['./account-change-email.component.scss'],
})
export class AccountChangeEmailComponent implements OnInit {
  public emailForm: FormGroup;

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.emailForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
    });
  }

  submitEmailChange(): void {
    if (!this.emailForm.valid) { return; }

    const { email } = this.emailForm.getRawValue();
    this.store.dispatch(new UpdateEmail(email)).subscribe(
      () => {},
      error => {
        if (error && error.status === 409) {
          this.emailForm.setErrors({ conflict: true });
        } else {
          this.emailForm.reset();
          this.emailForm.setErrors({ unknown: true });
        }
        this.store.dispatch(new StopLoading());
      }
    );
  }
}
